// extracted by mini-css-extract-plugin
export var alt = "BrandBar-module--alt--8f5a6";
export var container = "BrandBar-module--container--35241";
export var desktopOnly = "BrandBar-module--desktopOnly--086a1";
export var logoLink = "BrandBar-module--logoLink--a9e87";
export var main = "BrandBar-module--main--9bbff";
export var mobileOnly = "BrandBar-module--mobileOnly--a60b4";
export var styledRow = "BrandBar-module--styledRow--2839e";
export var textLeft = "BrandBar-module--textLeft--cc674";
export var visuallyHidden = "BrandBar-module--visuallyHidden--b62e0";